import { render, staticRenderFns } from "./url.vue?vue&type=template&id=4d64f3c5&lang=pug&"
var script = {}
import style0 from "./url.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d64f3c5')) {
      api.createRecord('4d64f3c5', component.options)
    } else {
      api.reload('4d64f3c5', component.options)
    }
    module.hot.accept("./url.vue?vue&type=template&id=4d64f3c5&lang=pug&", function () {
      api.rerender('4d64f3c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/url.vue"
export default component.exports